"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackAnimation = void 0;

var _styledComponents = require("styled-components");

var _InOutAnimation = require("./InOutAnimation");

var getMarginTop = function getMarginTop(props) {
  return props.selfHeight ? -props.selfHeight : 0;
};

var stackAnimationBase = (0, _styledComponents.css)(["transition:", ";margin-top:", "px;opacity:0;transform:translateY(50%);"], function (props) {
  return (0, _styledComponents.css)(["opacity ", "ms,margin-top ", "ms,transform ", "ms"], props.duration, props.duration, props.duration);
}, getMarginTop);
var stackAnimationEnter = (0, _styledComponents.css)(["opacity:1;margin-top:0;transform:translateY(0);"]);
var stackAnimationExit = (0, _styledComponents.css)(["opacity:0;margin-top:", "px;transform:translateY(-50%);"], getMarginTop);
var StackAnimation = (0, _InOutAnimation.createInOutAnimation)({
  baseStyles: stackAnimationBase,
  enterStyles: stackAnimationEnter,
  exitStyles: stackAnimationExit
});
exports.StackAnimation = StackAnimation;